import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";

const api: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  xsrfHeaderName: "X-CSRFToken",
  xsrfCookieName: "csrftoken",
  withCredentials: true,
});

export function setAuthorizationHeader(token: string) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function responseSuccess(response: AxiosResponse): AxiosResponse {
  return response;
}

export function responseError(error: AxiosError): Promise<never> {
  return Promise.reject(error);
}

api.interceptors.response.use(responseSuccess, responseError);

export default api;
